<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row>
      <v-col
        class="text-end mt-4"
      >
        <v-btn
          color="primary"
          outlined
          @click="open"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Profile
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #[`item.id`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.id }}
              </text-highlight>
            </template>
            <template #[`item.code`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.code ? item.code : '' }}
              </text-highlight>
            </template>
            <template #[`item.image`]="{ item }">
              <a
                v-if="item.image"
                @click="getImage(item)"
              >
                <v-icon
                  small
                  color="primary"
                >
                  fa-image
                </v-icon>
              </a>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openEdit(item.id)"
              >
                EDIT
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="softDelete(item.id)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <profile-form
      ref="profileForm"
      @success="success"
    />
    <image-form
      ref="imageForm"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import ProfileForm from '@/components/forms/profiles/ProfileForm';
import ImageForm from '@/components/forms/ImageForm';
import { mapState } from 'vuex';

export default {
  components: {
    ProfileForm,
    ImageForm,
  },
  data: () => ({
    items: [],
    locations: [],
    selectedLocationId: 0,
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Profile Code', value: 'code' },
      { text: 'Image', value: 'image' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Created By', value: 'created_by' },
      { text: 'Actions', value: 'actions', align: 'end' },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    loading: false,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get();
    },

    async get() {
      this.loading = true;
      const submitModel = {
        filters: {
        },
      };
      this.items = await this.$api.profile.read(submitModel);
      this.loading = false;
    },

    // async getImage(id) {
    //   if (!id) return;
    //   const res = await this.$api.profile.get(`image/${id}`);
    //   if (!res) return;

    //   this.$refs.imageForm.openDialog(res.image, res.name);
    // },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.profile.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.profileForm.open();
    },

    openEdit(id) {
      this.$refs.profileForm.open(id);
    },

    success() {
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async getImage(item) {
      const res = await this.$api.profile.get(`image/${item.id}`);
      if (!res || !res.image) {
        this.$bus.$emit('showError', 'No image found for this profile.');
        return;
      }
      this.openImageForm(res.image, res.image_mime_type, item.code);
    },

    openImageForm(photo, type, code) {
      this.$refs.imageForm.openDialog(photo, type, code);
    },

  },
};
</script>
